module.exports = __webpack_public_path__ + "img/qg_07.115d2cb2.png";